<template>
  <div>
    <vue-snotify></vue-snotify>
    <loading
      :active.sync="isLoading"
      :is-full-page="fullPage"
      :loader="$store.state.spinerLoader"
      :color="$store.state.spinerColor"
    ></loading>
    <div class="content-height">
      <b-card>
        <b-row align-v="center" slot="header">
          <b-col cols="8">
            <h3 class="mb-0">Contact Info</h3>
          </b-col>
        </b-row>

        <b-row>
          <b-col cols="4">
            <h3 class="mb-0">Client</h3>

            <div class="mb-3">
              <div>
                <label class="mb-0 contact-text">{{
                  clientData && clientData.name ? clientData.name : "N/A"
                }}</label>
              </div>
            </div>

            <div class="mb-3">

              <div>
                <label class="mb-0 contact-text">{{
                  clientData && clientData.street ? clientData.street : "N/A"
                }}</label>
              </div>
              <div>
                <label class="mb-0 contact-text"
                  >{{ clientData && clientData.city ? clientData.city : "N/A" }} {{ clientData && clientData.province ? clientData.province : "N/A" }}
                  {{ clientData && clientData.postCode ? clientData.postCode : "N/A" }}</label
                >
              </div>
              
            </div>

            <div class="mb-3">
              <label class="contact-text">{{
                clientData && clientData.phone ? clientData.phone : "N/A"
              }}</label>
            </div>

            <div class="mb-3">
              <label
                @click="openEmailClient(clientData.email)"
                class="mr-sm-3 contact-text"
                >{{ clientData && clientData.email ? clientData.email : "N/A" }}</label
              >
            </div>
          </b-col>

          <b-col cols="4">

          <div class="input-group">
            <h3 class="mb-0">Accountant</h3>

              <v-select
                ref="accountantDropdown"
                class="accountantSelect"
                :options="accountants"
                label="fullName"
                v-model="accountantData"
                :clearable="false"
                v-on:input="accountantChanged()"
              ></v-select>
          </div>
            

            <div class="mb-3">
              <div>
                <label class="contact-text">{{
                  accountantData && accountantData.organisationName
                    ? accountantData.organisationName
                    : "N/A"
                }}</label>
              </div>
              <div>
                <label class="mb-0 contact-text"
                  >{{
                    accountantData && accountantData.firstName
                      ? accountantData.firstName
                      : "N/A"
                  }}
                  {{
                    accountantData && accountantData.lastName
                      ? accountantData.lastName
                      : "N/A"
                  }}</label
                >
              </div>
              <div>
                <label class="mb-0 contact-text"
                  >{{
                    accountantData && accountantData.street
                      ? accountantData.street
                      : "N/A"
                  }}
                  {{
                    accountantData && accountantData.city
                      ? accountantData.city
                      : "N/A"
                  }}</label
                >
              </div>
              <div>
                <label class="mb-0 contact-text"
                  >{{
                    accountantData && accountantData.province
                      ? accountantData.province
                      : "N/A"
                  }}
                  {{
                    accountantData && accountantData.postCode
                      ? accountantData.postCode
                      : "N/A"
                  }}</label
                >
              </div>
            </div>

            <div class="mb-3">
              <label class="contact-text">{{
                accountantData && accountantData.phone
                  ? accountantData.phone
                  : "N/A"
              }}</label>
            </div>

            <div class="mb-3">
              <label
                @click="openEmailClient(accountantData.email)"
                class="mr-sm-3 contact-text"
                >{{
                  accountantData && accountantData.email
                    ? accountantData.email
                    : "N/A"
                }}</label
              >
            </div>
          </b-col>
        </b-row>
      </b-card>
    </div>
  </div>
</template>

<script>
import { mapActions, mapState } from "vuex";
import moment from "moment";
import mixins from "./../../mixins/common.js";

export default {
  data() {
    return {
      isLoading: false,
      fullPage: true,
      clientData: [],
      accountantData: [],
      accountants: []
    };
  },
  mixins: [mixins],
  mounted() {
    //clear snotofy
    this.clearSnotifyMessages();
    this.getAccountants().then((data) => {
      if(data && data.data){
        this.accountants = data.data;
      }
    })
  },
  props: ["claim_id", "client_id"],
  watch: {
    claim_id: function (newVal, oldVal) {
      this.getClientAccountantDetails();
    },
  },
  methods: {
    ...mapActions("admin", ["getClaimUserDetails","getAccountants", "updateAccountantForClaimRecord"]),
    getClientAccountantDetails() {
      let claimParams = {
        claim_id: this.claim_id,
      };
      this.getClaimUserDetails(claimParams).then((data) => {
        if (data && data.data) {
          this.clientData = data.data.client;
          this.accountantData = data.data.accountant;
        } else {
        }
      });
    },
    openEmailClient(email) {
      if (email) {
        window.location.href = "mailto:" + email + "?subject=Subject&body=";
      }
    },
    accountantChanged(){
      this.$nextTick(() => {
        const inputElement = this.$refs.accountantDropdown.$el.querySelector('input');
        if (inputElement) {
          inputElement.blur();
        }
      });

      let params = {
        claimId: this.claim_id,
        accountantId: this.accountantData.id
      };

      this.updateAccountantForClaimRecord(params);
    }
  },
  computed: {},
};
</script>

<style scoped>
.contact-text{
  color: black;
}

.accountantSelect{
  min-width: 150px;
  margin-top: -7px;
  margin-left: 10px;
}
</style>
